import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "abcModal",
    "abcForm",
    "summaryModal",
    "summaryFrame",
    "queueModal",
  ];

  openSkillPicker(event) {
    event?.preventDefault();
    document.getElementById("skill-picker-modal")?.showModal();
  }

  // Очередь навыков на телефоне — окно из переключателя «N из M ▾».
  openQueue(event) {
    event?.preventDefault();
    document.getElementById("skill-queue-modal")?.showModal();
  }

  openSummary(event) {
    event?.preventDefault();
    if (this.hasSummaryModalTarget) {
      this.summaryModalTarget.showModal();
    } else {
      document.getElementById("summary-modal")?.showModal();
    }
    // Итоги считаются на сервере — обновляем их при каждом открытии окна
    // Сначала спиннер, чтобы не показывать цифры прошлого открытия, пока идёт запрос.
    if (this.hasSummaryFrameTarget && this.summaryFrameTarget.complete) {
      this.summaryFrameTarget.innerHTML =
        '<div class="text-center text-xs text-gray-400 py-6"><i class="fa-solid fa-spinner fa-spin"></i></div>';
      this.summaryFrameTarget.reload();
    }
  }

  closeSummary(event) {
    event?.preventDefault();
    if (this.hasSummaryModalTarget) {
      this.summaryModalTarget.close();
    } else {
      document.getElementById("summary-modal")?.close();
    }
  }

  openIncidentModal(event) {
    event?.preventDefault();
    const lessonSkillId = event.currentTarget.dataset.lessonSkillId;
    if (this.hasAbcFormTarget && lessonSkillId) {
      const lessonId = this.element.dataset.lessonId || this.lessonIdFromUrl();
      this.abcFormTarget.action = `/lessons/${lessonId}/lesson_skills/${lessonSkillId}/behavior_incidents`;
    }
    if (this.hasAbcModalTarget) {
      this.abcModalTarget.showModal();
    } else {
      document.getElementById("abc-modal")?.showModal();
    }
  }

  closeAbc(event) {
    event?.preventDefault();
    if (this.hasAbcModalTarget) {
      this.abcModalTarget.close();
    } else {
      document.getElementById("abc-modal")?.close();
    }
  }

  lessonIdFromUrl() {
    const match = window.location.pathname.match(/\/lessons\/(\d+)\/live/);
    return match ? match[1] : null;
  }
}
